// import Vue from 'vue'
import baseContextComponent from "@/components/baseContextComponent";
import eventHub from "@/eventHub";
import helpers from "@/helpers";
import { datiViaggio } from "@/models/carrello/datiViaggio";
import { FlightAwareItem } from "@/models/carrello/flightAwareItem";
import { CarrelloInfoProdotto } from "@/models/carrello/infoProdotto";
import api from "@/services/api";
import moment from "moment";
import { runInThisContext } from "vm";
import { Component, Watch } from "vue-property-decorator";
import { mapState } from "vuex";

@Component({
	computed: {
		...mapState({
			datiViaggio: (state: any) => state.datiViaggio,
			prodottoSelezionato: (state: any) => state.prodottoSelezionato
		})
	}
})

export default class popupInfoVoli extends baseContextComponent {
	prodottoSelezionato!: CarrelloInfoProdotto;
	datiViaggio!: datiViaggio;
	maxVoli: number = 6;

	ricercaNumeroVolo: string = null;
	ricercaDataPartenza: Date = null;
	ricercaAeroportoPartenza: string = null;
	ricercaAeroportoDestinazione: string = null;

	numeroVoloFocus: boolean = false;
	dataPartenza1Focus: boolean = false;
	aeroportoPartenzaFocus: boolean = false;
	aeroportoDestinazioneFocus: boolean = false;
	dataPartenza2Focus: boolean = false;

	showRicerca: boolean = true;
	showRicercaAlternativa: boolean = false;
	showRisultati: boolean = false;
	showBtnAddVolo: boolean = false;

	risultatiRicerca: FlightAwareItem[] = [];
	erroreRicerca: string = null;
	erroreValidazioneCampi: string = null;

	voliSelezionati: FlightAwareItem[] = [];
	bloccaChiusura: boolean = false;

	@Watch("$route", { deep: true })
	onRouteChange(oldValue, newValue) {
		if(this.showModal)
			this.showModal = false;
	}
	showModal = false;
	// gestendo l'apertura di un solo messaggio per volta
	@Watch("showModal")
	onShowModalChange(oldValue, newValue) {
		if (this.showModal == false && this.bloccaChiusura) {
			this.tryOpen(this.voliSelezionati || null);
		}
		
	}

	get title(): string {
		return "Seleziona volo";
	}


	get titleSecondary(): string {
		return "";
	}
	get subTitle(): string {
		return "";
	}
	created() {
		var self = this;
		
		//eventHub.$on(eventHub.events.USER_INFO_UPDATED, () => api.getPopupCarrello().then(res => (this.messaggi = res || [])));
	}
	mounted() {}
	tryOpen(voli : FlightAwareItem[]) {
		if(this.showModal)
			return;
		this.showRicercaAlternativa = false;
		this.initDati(voli);
		this.showModal = true;
	}
	initDati(voli : FlightAwareItem[]) {
		this.numeroVoloFocus = false;
		this.dataPartenza1Focus = false;
		this.aeroportoPartenzaFocus = false;
		this.aeroportoDestinazioneFocus = false;
		this.dataPartenza2Focus = false;
		this.bloccaChiusura = false;

		this.risultatiRicerca = [];
		this.erroreRicerca = "";
		this.erroreValidazioneCampi = "";

		this.ricercaNumeroVolo = "";
		this.ricercaDataPartenza = null;
		this.ricercaAeroportoPartenza = "";
		this.ricercaAeroportoDestinazione = "";
		this.showRisultati = false;

		if( voli && voli.length){
			this.voliSelezionati = voli;
		
			this.showBtnAddVolo = true;
			this.showRicerca = false;
		}
		else{
			this.voliSelezionati = [];
		
			this.showBtnAddVolo = false;
			this.showRicerca = true;
		}




	}

	
	onRicerca() {
		this.erroreValidazioneCampi = "";
		if(!this.ricercaNumeroVolo){
			this.erroreValidazioneCampi = "Impostare il numero di volo";
			this.toastErroreValidazione(this.erroreValidazioneCampi);
			return;
		}
		if(!this.ricercaDataPartenza){ // CHECK FORMATO DATA
			this.erroreValidazioneCampi = "Impostare la data di partenza";
			this.toastErroreValidazione(this.erroreValidazioneCampi);
			return;
		}
		var dPartenza = moment(this.ricercaDataPartenza).format("YYYY-MM-DD");
		var url = `${api.endpoint.CARRELLO.INFO_VOLI}?numeroVolo=${this.ricercaNumeroVolo}&dataPartenza=${dPartenza}`;
		this.getInfoVoli(url);
	}

	onRicercaAlternativa() {
		this.erroreValidazioneCampi = "";
		if(!this.ricercaAeroportoPartenza){
			this.erroreValidazioneCampi = "Impostare l'aeroporto di partenza";
			this.toastErroreValidazione(this.erroreValidazioneCampi);
			return;
		}
		if(!this.ricercaAeroportoDestinazione){
			this.erroreValidazioneCampi = "Impostare l'aeroporto di destinazione";
			this.toastErroreValidazione(this.erroreValidazioneCampi);
			return;
		}
		if(!this.ricercaDataPartenza){ // CHECK FORMATO DATA
			this.erroreValidazioneCampi = "Impostare la data di partenza";
			this.toastErroreValidazione(this.erroreValidazioneCampi);
			return;
		}
		var dPartenza = moment(this.ricercaDataPartenza).format("YYYY-MM-DD");
		var url = `${api.endpoint.CARRELLO.INFO_VOLI}?aeroportoPartenza=${this.ricercaAeroportoPartenza}&aeroportoDestinazione=${this.ricercaAeroportoDestinazione}&dataPartenza=${dPartenza}`;
		this.getInfoVoli(url);
	}

	toastErroreValidazione(msg){
		this.$bvToast.toast(msg, {
			variant: "danger",
			title: "Errore validazione",
			solid: true
		});
	}

	
	getInfoVoli(url) {
		var self = this;

		//var dati = '{"scheduled":[{"ident":"LAN1781","ident_icao":"LAN1781","numero_volo_pdf":"LA1781","actual_ident":"ANE668","actual_ident_icao":"ANE668","actual_numero_volo_pdf":"YW668","aircraft_type":"A320","timestampPartenza_utc":"2025-06-19T08:10:00Z","timestampArrivo_utc":"2025-06-19T05:50:00Z","origin":"LIML","origin_icao":"LIML","aeroportoPartenzaIata":"LIN","origin_lid":null,"destination":"LEMD","destination_icao":"LEMD","aeroportoArrivoIata":"MAD","destination_lid":null,"fa_flight_id":null,"meal_service":"Business: Food for sale / Economy: Food for sale","seats_cabin_business":7,"seats_cabin_coach":170,"seats_cabin_first":0},{"ident":"AAL8540","ident_icao":"AAL8540","numero_volo_pdf":"AA8540","actual_ident":"IBE668","actual_ident_icao":"IBE668","actual_numero_volo_pdf":"IB668","aircraft_type":"A320","timestampPartenza_utc":"2025-06-19T08:10:00Z","timestampArrivo_utc":"2025-06-19T05:50:00Z","origin":"LIML","origin_icao":"LIML","aeroportoPartenzaIata":"LIN","origin_lid":null,"destination":"LEMD","destination_icao":"LEMD","aeroportoArrivoIata":"MAD","destination_lid":null,"fa_flight_id":null,"meal_service":"Business: Snack or brunch / Economy: Snack or brunch, Food for sale","seats_cabin_business":10,"seats_cabin_coach":114,"seats_cabin_first":0},{"ident":"QTR6946","ident_icao":"QTR6946","numero_volo_pdf":"QR6946","actual_ident":"IBE668","actual_ident_icao":"IBE668","actual_numero_volo_pdf":"IB668","aircraft_type":"A321","timestampPartenza_utc":"2025-06-19T08:10:00Z","timestampArrivo_utc":"2025-06-19T05:50:00Z","origin":"LIML","origin_icao":"LIML","aeroportoPartenzaIata":"LIN","origin_lid":null,"destination":"LEMD","destination_icao":"LEMD","aeroportoArrivoIata":"MAD","destination_lid":null,"fa_flight_id":null,"meal_service":"Business: No meal / Economy: No meal","seats_cabin_business":1,"seats_cabin_coach":216,"seats_cabin_first":0},{"ident":"VLG5121","ident_icao":"VLG5121","numero_volo_pdf":"VY5121","actual_ident":"IBE668","actual_ident_icao":"IBE668","actual_numero_volo_pdf":"IB668","aircraft_type":"","timestampPartenza_utc":"2025-06-19T08:10:00Z","timestampArrivo_utc":"2025-06-19T05:50:00Z","origin":"LIML","origin_icao":"LIML","aeroportoPartenzaIata":"LIN","origin_lid":null,"destination":"LEMD","destination_icao":"LEMD","aeroportoArrivoIata":"MAD","destination_lid":null,"fa_flight_id":null,"meal_service":"Economy: Food for sale","seats_cabin_business":0,"seats_cabin_coach":150,"seats_cabin_first":0},{"ident":"IBE668","ident_icao":"IBE668","numero_volo_pdf":"IB668","actual_ident":null,"actual_ident_icao":null,"actual_numero_volo_pdf":null,"aircraft_type":"A321","timestampPartenza_utc":"2025-06-19T08:10:00Z","timestampArrivo_utc":"2025-06-19T05:50:00Z","origin":"LIML","origin_icao":"LIML","aeroportoPartenzaIata":"LIN","origin_lid":null,"destination":"LEMD","destination_icao":"LEMD","aeroportoArrivoIata":"MAD","destination_lid":null,"fa_flight_id":null,"meal_service":"Economy: Snack or brunch, Food for sale","seats_cabin_business":0,"seats_cabin_coach":220,"seats_cabin_first":0},{"ident":"IBE664","ident_icao":"IBE664","numero_volo_pdf":"IB664","actual_ident":null,"actual_ident_icao":null,"actual_numero_volo_pdf":null,"aircraft_type":"A320","timestampPartenza_utc":"2025-06-19T12:00:00Z","timestampArrivo_utc":"2025-06-19T09:40:00Z","origin":"LIML","origin_icao":"LIML","aeroportoPartenzaIata":"LIN","origin_lid":null,"destination":"LEMD","destination_icao":"LEMD","aeroportoArrivoIata":"MAD","destination_lid":null,"fa_flight_id":null,"meal_service":"Economy: Snack or brunch, Food for sale","seats_cabin_business":0,"seats_cabin_coach":180,"seats_cabin_first":0},{"ident":"AAL8541","ident_icao":"AAL8541","numero_volo_pdf":"AA8541","actual_ident":"IBE664","actual_ident_icao":"IBE664","actual_numero_volo_pdf":"IB664","aircraft_type":"A320","timestampPartenza_utc":"2025-06-19T12:00:00Z","timestampArrivo_utc":"2025-06-19T09:40:00Z","origin":"LIML","origin_icao":"LIML","aeroportoPartenzaIata":"LIN","origin_lid":null,"destination":"LEMD","destination_icao":"LEMD","aeroportoArrivoIata":"MAD","destination_lid":null,"fa_flight_id":null,"meal_service":"Business: Snack or brunch / Economy: Snack or brunch, Food for sale","seats_cabin_business":10,"seats_cabin_coach":114,"seats_cabin_first":0},{"ident":"VLG5115","ident_icao":"VLG5115","numero_volo_pdf":"VY5115","actual_ident":"IBE664","actual_ident_icao":"IBE664","actual_numero_volo_pdf":"IB664","aircraft_type":"","timestampPartenza_utc":"2025-06-19T12:00:00Z","timestampArrivo_utc":"2025-06-19T09:40:00Z","origin":"LIML","origin_icao":"LIML","aeroportoPartenzaIata":"LIN","origin_lid":null,"destination":"LEMD","destination_icao":"LEMD","aeroportoArrivoIata":"MAD","destination_lid":null,"fa_flight_id":null,"meal_service":"Economy: Food for sale","seats_cabin_business":0,"seats_cabin_coach":150,"seats_cabin_first":0},{"ident":"QTR6925","ident_icao":"QTR6925","numero_volo_pdf":"QR6925","actual_ident":"IBE664","actual_ident_icao":"IBE664","actual_numero_volo_pdf":"IB664","aircraft_type":"A320","timestampPartenza_utc":"2025-06-19T12:00:00Z","timestampArrivo_utc":"2025-06-19T09:40:00Z","origin":"LIML","origin_icao":"LIML","aeroportoPartenzaIata":"LIN","origin_lid":null,"destination":"LEMD","destination_icao":"LEMD","aeroportoArrivoIata":"MAD","destination_lid":null,"fa_flight_id":null,"meal_service":"Business: No meal / Economy: No meal","seats_cabin_business":1,"seats_cabin_coach":185,"seats_cabin_first":0},{"ident":"VLG5267","ident_icao":"VLG5267","numero_volo_pdf":"VY5267","actual_ident":"IBE666","actual_ident_icao":"IBE666","actual_numero_volo_pdf":"IB666","aircraft_type":"","timestampPartenza_utc":"2025-06-19T20:40:00Z","timestampArrivo_utc":"2025-06-19T18:20:00Z","origin":"LIML","origin_icao":"LIML","aeroportoPartenzaIata":"LIN","origin_lid":null,"destination":"LEMD","destination_icao":"LEMD","aeroportoArrivoIata":"MAD","destination_lid":null,"fa_flight_id":null,"meal_service":"Economy: Food for sale","seats_cabin_business":0,"seats_cabin_coach":150,"seats_cabin_first":0},{"ident":"IBE666","ident_icao":"IBE666","numero_volo_pdf":"IB666","actual_ident":null,"actual_ident_icao":null,"actual_numero_volo_pdf":null,"aircraft_type":"A320","timestampPartenza_utc":"2025-06-19T20:40:00Z","timestampArrivo_utc":"2025-06-19T18:20:00Z","origin":"LIML","origin_icao":"LIML","aeroportoPartenzaIata":"LIN","origin_lid":null,"destination":"LEMD","destination_icao":"LEMD","aeroportoArrivoIata":"MAD","destination_lid":null,"fa_flight_id":null,"meal_service":"Economy: Snack or brunch, Food for sale","seats_cabin_business":0,"seats_cabin_coach":177,"seats_cabin_first":0},{"ident":"LAN1658","ident_icao":"LAN1658","numero_volo_pdf":"LA1658","actual_ident":"IBE666","actual_ident_icao":"IBE666","actual_numero_volo_pdf":"IB666","aircraft_type":"A320","timestampPartenza_utc":"2025-06-19T20:40:00Z","timestampArrivo_utc":"2025-06-19T18:20:00Z","origin":"LIML","origin_icao":"LIML","aeroportoPartenzaIata":"LIN","origin_lid":null,"destination":"LEMD","destination_icao":"LEMD","aeroportoArrivoIata":"MAD","destination_lid":null,"fa_flight_id":null,"meal_service":"Business: Food for sale / Economy: Food for sale","seats_cabin_business":7,"seats_cabin_coach":179,"seats_cabin_first":0},{"ident":"QTR7236","ident_icao":"QTR7236","numero_volo_pdf":"QR7236","actual_ident":"IBE666","actual_ident_icao":"IBE666","actual_numero_volo_pdf":"IB666","aircraft_type":"A320","timestampPartenza_utc":"2025-06-19T20:40:00Z","timestampArrivo_utc":"2025-06-19T18:20:00Z","origin":"LIML","origin_icao":"LIML","aeroportoPartenzaIata":"LIN","origin_lid":null,"destination":"LEMD","destination_icao":"LEMD","aeroportoArrivoIata":"MAD","destination_lid":null,"fa_flight_id":null,"meal_service":"Business: No meal / Economy: No meal","seats_cabin_business":1,"seats_cabin_coach":185,"seats_cabin_first":0},{"ident":"AAL8540","ident_icao":"AAL8540","numero_volo_pdf":"AA8540","actual_ident":"IBE668","actual_ident_icao":"IBE668","actual_numero_volo_pdf":"IB668","aircraft_type":"A320","timestampPartenza_utc":"2025-06-20T08:10:00Z","timestampArrivo_utc":"2025-06-20T05:50:00Z","origin":"LIML","origin_icao":"LIML","aeroportoPartenzaIata":"LIN","origin_lid":null,"destination":"LEMD","destination_icao":"LEMD","aeroportoArrivoIata":"MAD","destination_lid":null,"fa_flight_id":null,"meal_service":"Business: Snack or brunch / Economy: Snack or brunch, Food for sale","seats_cabin_business":10,"seats_cabin_coach":114,"seats_cabin_first":0},{"ident":"QTR6946","ident_icao":"QTR6946","numero_volo_pdf":"QR6946","actual_ident":"IBE668","actual_ident_icao":"IBE668","actual_numero_volo_pdf":"IB668","aircraft_type":"A321","timestampPartenza_utc":"2025-06-20T08:10:00Z","timestampArrivo_utc":"2025-06-20T05:50:00Z","origin":"LIML","origin_icao":"LIML","aeroportoPartenzaIata":"LIN","origin_lid":null,"destination":"LEMD","destination_icao":"LEMD","aeroportoArrivoIata":"MAD","destination_lid":null,"fa_flight_id":null,"meal_service":"Business: No meal / Economy: No meal","seats_cabin_business":1,"seats_cabin_coach":216,"seats_cabin_first":0}],"links":{"next":"/schedules/2025-06-19T00%3a00%3a00Z/2025-06-21T23%3a59%3a00Z?origin=LIN&destination=MAD&cursor=1930806272d43a9"},"num_pages":1}';
		// var dati = '[{"vendor":{"ident":"EZY5182","ident_icao":"EZY5182","ident_iata":"U25182","actual_ident":null,"actual_ident_icao":null,"actual_ident_iata":null,"aircraft_type":"A320","scheduled_in":"2025-05-06T08:15:00Z","scheduled_out":"2025-05-06T06:30:00Z","origin":"LSGG","origin_icao":"LSGG","origin_iata":"GVA","origin_lid":null,"destination":"EDDB","destination_icao":"EDDB","destination_iata":"BER","destination_lid":null,"fa_flight_id":"EZY5182-1746340564-schedule-218p","meal_service":"Economy: No meal","seats_cabin_business":0,"seats_cabin_coach":180,"seats_cabin_first":0},"numero_volo_pdf":"EJU5182","numeroVolo":"EZY5182","timestampPartenza_utc":"2025-05-30 17:25Z","timestampArrivo_utc":"2025-05-30 21:35Z","timestampPartenza":"2025-05-30 19:25+02:00","timestampArrivo":"2025-05-31 00:35+03:00","aeroportoPartenza":"LIMC","aeroportoPartenzaNome":"Malpensa","aeroportoPartenzaIata":"MXP","aeroportoArrivo":"OJAI","aeroportoArrivoNome":"Queen Alia International Airport","aeroportoArrivoIata":"AMM"}]';
		
		// self.risultatiRicerca = ( JSON.parse(dati) || []  ) as FlightAwareItem[];
		// self.showRisultati = true;


		var res = api.get(url).then(data => {
			debugger
			var voli = ( data && data.data && data.data.item1 && data.data.item1.scheduled ? data.data.item1.scheduled : [] ) as FlightAwareItem[];
			self.risultatiRicerca = voli;
			self.showRisultati = true;
			self.erroreRicerca = voli && voli.length ? "" : "Non è stato rilevato alcun volo che soddisfa i parametri inseriti";
			if(data && data.data && data.data.item2 && data.data.item2.length){
				self.$bvToast.toast(data.data.item2.join("\n"), {
					variant: "danger",
					title: self.$i18n.t('msg.erroreGenerico').toString(),
					solid: true
				});
			}
		})
		.catch((err) => {
			debugger
			self.risultatiRicerca = [];
			self.showRisultati = true;
			self.erroreRicerca =  "Non è stato rilevato alcun volo che soddisfa i parametri inseriti";
		});
	}

	isVoloSelezionato(volo: FlightAwareItem){
		return this.voliSelezionati.find( x => x.numeroVolo === volo.numeroVolo && x.aeroportoPartenzaIata == volo.aeroportoPartenzaIata && x.aeroportoArrivoIata == volo.aeroportoArrivoIata);
	}

	onSelezionaVolo(volo: FlightAwareItem){
		if(this.voliSelezionati.length >= this.maxVoli){
			// ritorna messaggio max voli selezionati
			return;
		}
		if(this.isVoloSelezionato(volo)){
			// volo gia' selezionato
			return;
		}
		var v = helpers.cloneObject(volo) as FlightAwareItem;
		this.voliSelezionati.push(v);
		this.azzeraRisultati();
		this.hideRicerca();
		this.showBtnAddVolo = true;
	}

	onCancellaVolo(volo: FlightAwareItem){
		var index = this.voliSelezionati.findIndex( x => x.numeroVolo === volo.numeroVolo && x.aeroportoPartenzaIata == volo.aeroportoPartenzaIata && x.aeroportoArrivoIata == volo.aeroportoArrivoIata) ;
		if(index >= 0)
			this.voliSelezionati.splice(index, 1);
		if(!this.voliSelezionati.length){
			this.showBtnAddVolo = false;
			this.showRicerca = true;
		}
	}

	azzeraRisultati() {
		this.risultatiRicerca = [];
		this.showRisultati = false;
		this.erroreRicerca = ""
	}

	hideRicerca(){
		this.showRicerca = false;
		this.showRicercaAlternativa = false;
	}

	onAddAltroVolo() {
		this.showBtnAddVolo = false;
		this.showRicerca = true;
	}

	onSalva(){
		var dati = ( helpers.cloneObject(this.voliSelezionati || []) || [] ) as FlightAwareItem[];
		this.$emit("onSalva", dati);
		this.showModal = false;
	}

	onAnnulla(){
		this.showModal = false;
	}

	// get appWidth(): boolean {
	// 	var pixelRatio = 1;

	// 	if (window && window.devicePixelRatio > 1) {
	// 		pixelRatio = window.devicePixelRatio
	// 	}

	// 	// if (pixelRatio > 1.5) {
	// 	// 	return this.appWidth < brkp_mobile_large;
	// 	// }
		
	// 	return this.appWidth <= brkp_mobile;
	// 	//return this.lgAndDown;
	// }
}
